'use strict';

gs.component('bankgiroConfirmList', {
    templateUrl: '/components/bankgiro/confirm/confirm-list.html',
    link: function(DI) {
        var $scope = DI.$scope;
        $scope.loadingStatus = {};
        DI.$controller('EconomyCtrl', {$scope: $scope});

        $scope.data = {
            toDate: Date.today().addDays(25),
            loading: false
        };

        var getIds = function(payments) {
            var ids = [];
            angular.forEach(payments, function(payment) {
                ids = ids.concat(_.pluck(payment.parts, 'id'));
            });
            return ids;
        };

        $scope.confirm = function(payment) {
            $scope.loadingStatus.loading = true;
            var payments = payment ? [payment] : $scope.pendingConfig.control.getFilteredItems();

            var confirmPayments = function(delayBelowMin) {
                var ids = getIds(payments);
                DI.server.post2('/api/payment/confirm', {payments: ids, delayBelowMin: !!delayBelowMin}, {
                    successAlert: 'Payments confirmed',
                    errorAlert: 'Failed to confirm payments'
                }).then(function() {
                    $scope.loadingStatus.loading = false;
                }, function() {
                    $scope.loadingStatus.loading = false;
                });
            };

            var delay = function() { confirmPayments(true); };
            var skipDelay = function() { confirmPayments(false); };
            if (!$scope.allAboveMinAmount(payments)) {
                DI.$modal.open({
                    templateUrl: 'views/paymentconfirmationoptionmodal.html',
                    controller: 'PaymentConfirmationOptionModalCtrl',
                }).result.then(function(result) {
                    if (result.delayBelowMin) { delay(); }
                    else { skipDelay(); }
                }, function() {
                    $scope.loadingStatus.loading = false;
                });
            } else {
                skipDelay();
            }
        };

        $scope.allAboveMinAmount = function(payments) {
            if (!$scope.ddsettings || !$scope.ddsettings.minAmount) {
                return true;
            }
            var minAmount = Number($scope.ddsettings.minAmount);
            var hasPaymentBelowMin = !!_.find(payments, function(p) { return p.amount < minAmount; });
            return !hasPaymentBelowMin;
        };

        var paymentList;
        var allPayments; // Store all payments before filtering
        var legalEntityId;

        // Helper function to check if payer has consent for the current legal entity
        var hasConsent = function(payer) {
            if (!payer || !payer.consents || !legalEntityId) {
                return false;
            }
            return payer.consents[legalEntityId] === true;
        };

        $scope.reloadPayments = function() {
            var to = $scope.data.toDate;
            legalEntityId = DI.$rootScope.selectedSite.legal_entity_id;
            if (!to || to.getFullYear() < 1900 || !legalEntityId) {
                return;
            }

            $scope.data.loading = true;
            DI.server.post2('/api/payment/get_list', {
                status: DI.$attrs.status.split(','),
                to_date: to,
                confirmed: false,
                method: 'directdebit',
                legal_entity_id: legalEntityId
            }).then(function(result) {
                return DI.$rootScope.waitFor(['members', 'staffs', 'sites']).then(function() {
                    result.forEach(DI.$rootScope.transformPayment);
                    allPayments = $scope.bundleTogether(result, true);

                    // Get all unique payer IDs
                    const payerIds = _.uniq(_.pluck(allPayments, 'payer_id'));

                    // If no payers, skip async loading
                    if (payerIds.length === 0) {
                        paymentList = [];
                        $scope.data.loading = false;
                        if ($scope.pendingConfig.control) {
                            $scope.pendingConfig.control.update();
                        }
                        return;
                    }

                    // Load all payers asynchronously
                    return DI.$rootScope.getMembersAsync(payerIds).then(() => {
                        // Now all payers are loaded, filter to only show payments with consent
                        paymentList = allPayments.filter(p => hasConsent(p.payer));

                        $scope.data.loading = false;

                        // Trigger table update
                        if ($scope.pendingConfig.control) {
                            $scope.pendingConfig.control.update();
                        }
                    });
                });
            }).catch(function(error) {
                console.error('Error loading payments:', error);
                $scope.data.loading = false;
            });
        };

        $scope.getNumberOfMissingConsents = function() {
            if (!allPayments) return 0;

            // Count unique payers without consent (from all payments, not just filtered ones)
            let payersWithoutConsent = {};
            allPayments.forEach(p => {
                if (!hasConsent(p.payer)) {
                    payersWithoutConsent[p.payer.id] = true;
                }
            });
            return Object.keys(payersWithoutConsent).length;
        };

        $scope.getMissingConsentsString = function() {
            return DI.$filter('translate')('Missing consents for {0} payments. Go to Economy > Missing consents to see these').format($scope.getNumberOfMissingConsents());
        };

        $scope.pendingConfig = {
            getItems: function() {
                return paymentList;
            },
            countSuffixList: ['payment', 'payments'],
            hideSearch: true,
            rowClick: $scope.showPayments,
            orderColumn: 'date',
            hidePaymentSearch: true,
            getTitle: function() {
                return 'Pending payments';
            },
            columns: [
                {field: 'image', title: '', src: $scope.getImage },
                {field: 'payer.name', title: 'Payer' },
                {field: 'date', title: 'Due date', format: 'date' },
                {field: 'name', title: 'Payment item', getValue: $scope.getProductName },
                {field: 'method', title: 'Payment method', getValue: $scope.getPaymentMethodName },
                {field: 'totalamount', title: 'Amount', format: 'price' }
            ],
            buttons: [{ title: 'Confirm', buttonClass: 'btn-success', onClick: $scope.confirm }],
            searchButtons: [{title: 'Download as Excel', onClick: $scope.getExcel }]
        };

        var removeServerChange = DI.$rootScope.$on('serverChange', function (event, message) {
            if (message.type == 'payment') {
                $scope.reloadPayments();
            }
        });

        $scope.$on('$destroy', function () {
            removeServerChange();
        });

        DI.server.get('/api/directdebit/settings/get', { legal_entity_id: DI.$rootScope.selectedSite.legal_entity_id }).then(function(data) {
            $scope.ddsettings = data;
        });

        $scope.reloadPayments();

        $scope.allowSend = function() {
            return DI.$rootScope.allowAutogiroSend;
        };

        $scope.sendAutogiro = function() {
            DI.server.post2('/api/admin/bankgiro/export').then(function() {
                DI.alertProvider.show('success', 'Autogiro sending is started');
            }, function() {
                DI.alertProvider.show('error', 'Error');
            });
        };
    }
});
